jQuery(function($) {
    $('[data-trigger]').on('click', function(e) {
        e.preventDefault();

        let currentRow = $(this).closest('.program-disponibility-table').find('[data-trigger].expanded').attr('data-trigger') || 0,
            nextRow = $(this).attr('data-trigger');

        $(`[data-trigger="${currentRow}"]`).removeClass('expanded');
        $(`[data-trigger="${currentRow}"] ~ .row-container[data-rooms="${currentRow}"]`).slideUp();

        if(currentRow !== nextRow) {
            $(`[data-trigger="${nextRow}"]`).addClass('expanded');
            $(`[data-trigger="${nextRow}"] ~ .row-container[data-rooms="${nextRow}"]`).slideDown();
        }
    })
})